import { render, staticRenderFns } from "./RpaUltra.vue?vue&type=template&id=2a52f768&scoped=true&"
import script from "./RpaUltra.vue?vue&type=script&lang=js&"
export * from "./RpaUltra.vue?vue&type=script&lang=js&"
import style0 from "./RpaUltra.vue?vue&type=style&index=0&id=2a52f768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52f768",
  null
  
)

export default component.exports